import {
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';

import { AUTH_CONFIG, authConfig, PartialAuthConfig } from '../auth.config';
import { initializeTmxAuth } from './initialize-tmx-auth';

/**
 * Add this to your root Application Config Providers array or your root AppModule Providers array
 * if your application is not bootstrapped using standalone components.
 *
 * @param config Configuration object to override default values
 * @returns Environment Providers that set the Authentication Library Configuration and initialize the library
 *
 * @example
 * ```ts
 * export const appConfig: ApplicationConfig = {
 *   providers: [
 *     provideRouter(appRoutes),
 *     {
 *       provideAuthConfig({
 *         text: {
 *           appName: 'Your Application Name'
 *         },
 *         trimbleIdentity: {
 *           trimbleCloudAppName: environment.tidAppName,
 *           trimbleCloudClientId: environment.tidClientId,
 *           trimbleMapsAppName: environment.appName,
 *         }
 *       })
 *     }
 *   ]
 * }
 * ```
 */
export const provideAuthConfig = (config: PartialAuthConfig) =>
  makeEnvironmentProviders([
    {
      provide: AUTH_CONFIG,
      useValue: authConfig(config),
    },
    provideAppInitializer(() => {
      const initializerFn = initializeTmxAuth(inject(AUTH_CONFIG));
      return initializerFn();
    }),
  ]);
